<script setup>
const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
})
const emit = defineEmits(['input'])

</script>

<template>
  <input
    class="self-stretch h-12 pl-4 pr-5 py-4 bg-stone-50 border-b border-stone-700 justify-start items-center gap-5 inline-flex"
    :type="type"
    :value="props.value"
    @input="(e)=>{ emit('input', e.target.value) }"
  >
</template>

<style scoped>

</style>
